import React from "react";
import { Link } from "react-router-dom";
import BlueImage from "../../assets/images/blue.jpeg";
import Candidate from "../../assets/images/HomePage/candidate image/260X260.jpg";
const NewsData = [
  {
    id: 1,
    title: "اموال الشعب",
    img: "https://i.ytimg.com/vi/a0qeJ4aqLjg/mqdefault.jpg",
    link: "https://youtube.com/shorts/a0qeJ4aqLjg?feature=share",
    //descripti: "تم انشاء هذا الخبر ليكون مثال للخبر الاول",
  },

  {
    id: 2,
    title: "المعادلة باختصار",
    img: "https://i.ytimg.com/vi/OTF2EbvXn-I/mqdefault.jpg",
    link: "https://youtube.com/shorts/OTF2EbvXn-I?feature=share",
   // descripti: "تم انشاء هذا الخبر ليكون مثال للخبر الثاني",
  },
  {
    id: 3,
    title: "صناديق الشعب",
    img: "https://i.ytimg.com/vi/ERbgQdWaPog/mqdefault.jpg",
    link: "https://youtube.com/shorts/ERbgQdWaPog?feature=share",
    //descripti: "تم انشاء هذا الخبر ليكون مثال للخبر الثالث",
  },
  {
    id: 4,
    title: "الانتخابات القادمة مفصلية",
    img: "https://i.ytimg.com/vi/e0iXsZem35k/mqdefault.jpg",
    link: "https://youtu.be/e0iXsZem35k",
    //descripti: "تم انشاء هذا الخبر ليكون مثال للخبر الرابع",
  },
 /*  {
    id: 5,
    title: "خبر 5",
    img: Candidate,
    link: "#",
    descripti: "تم انشاء هذا الخبر ليكون مثال للخبر الخامس",
  },
  {
    id: 6,
    title: "خبر 6",
    img: Candidate,
    link: "#",
    descripti: "تم انشاء هذا الخبر ليكون مثال للخبر السادس",
  }, */
];

const NecessaryLinks = [
  /* {
    id: 1,
    title: "اطلع على الخبر كاملا",
    link: "#",
  },
  {
    id: 2,
    title: "اطلع على الخبر كاملا",
    link: "#",
  },
  {
    id: 3,
    title: "اطلع على الخبر كاملا",
    link: "#",
  },
  {
    id: 4,
    title: "اطلع على الخبر كاملا",
    link: "#",
  },
  {
    id: 5,
    title: "اطلع على الخبر كاملا",
    link: "#",
  },
  {
    id: 6,
    title: "اطلع على الخبر كاملا",
    link: "#",
  }, */
];
function NewsCom() {
  return (
    <div>
      <div className="row">
        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <h2 className="text-center bg-dark text-light  my-3 rounded-pill py-3">
            {" "}
            اخر الاخبار <i className="fas fa-newspaper"></i>
          </h2>
          {NewsData.map((item, index) => {
            return (
              <div className="d-flex justify-content-start align-items-center">
                <img
                  src={item.img}
                  alt="news"
                  className="img-fluid rounded-3"
                  style={{ width: "80px", height: "80px" }}
                />
                <div className="d-flex flex-column justify-content-start align-items-start p-3">
                  <Link to={item.link} target="_blank" className=" text-dark">
                    <h2 className="text-decoration-none">{item.title}</h2>
                  </Link>
                  <h3 className="my-2 text-decoration-none">
                  {/*   {item.descripti} */}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
         {/*  <div className="w-100">
            <h2 className="text-center bg-dark text-light my-3 rounded-pill py-3">
              روابط هامة <i className="fas fa-link"></i>
            </h2>
          </div> */}

          <div className="d-flex flex-column justify-content-center align-items-center">
            {NecessaryLinks.map((item, index) => {
              return (
                <div className="d-flex justify-content-start align-items-center">
                  <i className="fas fa-link fa-2x text-dark"></i>
                  <div className="d-flex flex-column justify-content-start align-items-start p-3">
                    <Link to={item.link} className=" text-dark">
                      <h2 className="text-decoration-none">{item.title}</h2>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsCom;
